/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RoleEnum = {
    Unassigned: 'UNASSIGNED',
    Admin: 'ADMIN',
    PatientOps: 'PATIENT_OPS',
    Therapist: 'THERAPIST',
    Public: 'PUBLIC',
    PatientOpsLead: 'PATIENT_OPS_LEAD',
    PracticeManager: 'PRACTICE_MANAGER',
    PatientOpsDirector: 'PATIENT_OPS_DIRECTOR',
    ClinicalDirector: 'CLINICAL_DIRECTOR'
} as const;
export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];

